export default __webpack_public_path__ + "static/media/plane.7bd7255b.png";